module.exports = __webpack_public_path__ + "img/slphouse_main10.71a2fef6.png";